import Select2Component from 'components/select2Component';
import React, {forwardRef, useEffect, useState} from 'react';
import axios from 'axios';
import VariaveisGlobais from 'variaveis_globais/variaveis_globais';

export var AgendaSelect2Component = forwardRef((props, ref) => {
    
    const [items, setaItems] = useState([]);

    useEffect(() => {
        axios.get(`https://www.gsdoctor.com.br/service/api/AgendaRecursos/GetComboAgendaRecursos?idEmpresa=${VariaveisGlobais.idClinica}`, {
            headers: {
                Authorization: 'Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiI1IiwidW5pcXVlX25hbWUiOiJSaWNhcmRvIiwibmJmIjoxNzQ2MDE2OTM5LCJleHAiOjE4NDA3MTEzMzksImlhdCI6MTc0NjAxNjkzOSwiaXNzIjoiZ3Nkb2N0b3IuY29tLmJyIiwiYXVkIjoiaHR0cHM6Ly93d3cuZ3Nkb2N0b3IuY29tLmJyIn0.M3d0Fb4lzCrJUWCSMIgeGntH2EPsHMIdk6JQ5r247Cy68doKwCh22E-xEKZWo0aXwiDSpkuaJ33rcUNgcDUc3g'
            }
        }).then( (requisicao) => {
            if (requisicao.status == 200) {
                const agendas = requisicao.data.map((v) => {
                    return {
                       label: v.NomeRecurso,
                       value: v.Id
                    }
                });
                agendas.unshift({
                    value: 'TodasAgendas',
                    label: 'Todos'
                });
                setaItems(agendas);
            }
        }).catch(() => {

        });

    },[])

    return (
        <Select2Component   isMulti={true} ref={ref} id={props.id}  items={items}/>
    )
});